import TextWithImageLeft2 from './TextWithImageLeft2';

export default TextWithImageLeft2;